import * as React from 'react'
import type { ImageViewModel } from '../../view-models/ImageViewModel'
import type { OptionAccordionsViewModel } from '../../view-models/OptionAccordionsViewModel'
import MediaQuery from '@/components/MediaQuery/MediaQuery'

import AccordionItem from '@/modules/Accordion/AccordionItem'
import HeadingWithImg from '@/components/HeadingWithImg/HeadingWithImg'
import styles from '@/modules/Accordion/accordion-style.css'

export type AccordionProps = {
  items: Array<OptionAccordionsViewModel>
  title: string
  avatar?: ImageViewModel
  icon?: string
  id?: string

  /*will be sent by backend for the Anchor Points*/
  hideDivider?: boolean
}

const Accordion = ({ items, title, avatar, icon, id, hideDivider }: AccordionProps) => {
  return (
    <MediaQuery defaultMatches={true} query={'(min-width: 769px)'}>
      {(matches) =>
        matches ? (
          <div className={styles.accordion}>
            <div className={styles.grid}>
              <div className={styles.gridItem}>
                <HeadingWithImg title={title} icon={icon} image={avatar} />
              </div>
              <div className={styles.gridItem}>
                <AccordionItem items={items} title={title} avatar={avatar} icon={icon} id={id}
                               hideDivider={hideDivider} />
              </div>
            </div>
          </div>

        ) : (
          <div className={styles.accordion}>
            <HeadingWithImg title={title} icon={icon} image={avatar} />
            <AccordionItem items={items} title={title} avatar={avatar} icon={icon} id={id} hideDivider={hideDivider} />
          </div>

        )}
    </MediaQuery>
  )
}


export default Accordion